import React from "react";
import ApplyFranchise from "../../../components/contactComponent/ApplyFranchise";
import { Box } from "@mui/material";
import FooterSr from "../components/Footersr";
import GetInTouchSection from "../../../components/contactComponent/GetInTouch";
import News from "../../../components/globalCountries/countryhomepagescomponent/News";
import AccordionUsage from "../../../components/contactComponent/Accordin";
const ContactusSr = () => {
  return (
    <Box>
      <ApplyFranchise />
      <GetInTouchSection />
      <AccordionUsage />
      <News />
      <Box sx={{ height: "80px" }} />
      <FooterSr />
    </Box>
  );
};

export default ContactusSr;
